import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-gap-2 tw-px-2" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-h-full tw-items-center"
}

import CheckboxIcon from "@/components/svgs/checkboxIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cellDetailType1',
  props: {
    title: {},
    isIgnored: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "tw-text-[12px] tw-font-normal tw-break-words tw-text-justify",
      style: _normalizeStyle(`color: ${_ctx.isIgnored ? '#DBDBDB' : '#211F58'}`)
    }, _toDisplayString(_ctx.title), 5),
    (!_ctx.isIgnored)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CheckboxIcon)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})